import { REMI_INTERNAL_ORG } from "@remi/types/organizations";

import { useUserProfile } from "~/contexts/UserProfileContext";
import { ContactHeader } from "./components/ContactHeader";
import { ContactMethodButtons } from "./components/ContactMethodButtons";
import { PersonNoteSection } from "./components/PersonNoteSection";

type ExternalPersonCardProps = {
  personId: string;
  showButtons?: boolean;
};

export const ExternalPersonCard = ({ personId, showButtons = true }: ExternalPersonCardProps) => {
  const { user } = useUserProfile();
  const isRemiInternalViewer = user.person.organizationId === REMI_INTERNAL_ORG.id;

  return (
    <>
      <ContactHeader personId={personId} showButtons={showButtons} />
      {isRemiInternalViewer && <PersonNoteSection personId={personId} />}
      {isRemiInternalViewer && showButtons && <ContactMethodButtons personId={personId} />}
    </>
  );
};
